module.exports = __webpack_public_path__ + "static/don31-107c8a88d196c91956d006593ae673a5.jpg";